import React from 'react';
import Layout from '../../components/Layout';
import { MailIcon } from 'lucide-react';
const Communications: React.FC = () => {
  return <Layout title="Communications" persona="University Coordinator" universityName="UAE Business School" data-id="element-6041">
      <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-6042">
        <div className="text-center py-16" data-id="element-6043">
          <div className="mx-auto w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4" data-id="element-6044">
            <MailIcon className="w-8 h-8 text-gray-400" data-id="element-6045" />
          </div>
          <h3 className="text-gray-500 font-medium mb-2" data-id="element-6046">
            Communications content coming soon
          </h3>
          <p className="text-gray-400 text-sm max-w-md mx-auto" data-id="element-6047">
            This page will allow you to manage all communications with
            applicants and students.
          </p>
        </div>
      </div>
    </Layout>;
};
export default Communications;